import { AutogenModelEdipartnerXcmp, AutogenRowEdipartnerXcmp } from "./autogen/AutogenModelEdipartnerXcmp";

export class ModelEdipartnerXcmp extends AutogenModelEdipartnerXcmp<RowEdipartnerXcmp> {
	constructor() {
		super(RowEdipartnerXcmp);
	}
}

export class RowEdipartnerXcmp extends AutogenRowEdipartnerXcmp {
}